import type { AudioManager } from '../../audio/AudioManager';
import type { TouchInput } from '../../input/TouchInput';
import { LOGICAL_HEIGHT, LOGICAL_WIDTH } from '../../render/Renderer';
import { drawButton, pointInRect } from '../../render/ui/UI';
import type { Rect, RunSummary } from '../../types';
import type { Phase } from '../Phase';

const ADVANCE_BUTTON: Rect = { x: 60, y: 560, w: LOGICAL_WIDTH - 120, h: 56 };

export class GameOverPhase implements Phase {
  private summary: RunSummary;
  private audio: AudioManager;
  private done = false;
  private unbind: (() => void) | null = null;
  private elapsed = 0;

  constructor(summary: RunSummary, input: TouchInput, audio: AudioManager) {
    this.summary = summary;
    this.audio = audio;
    this.unbind = input.onPointerDown((e) => {
      if (this.elapsed > 1.0 && pointInRect(e.pos.x, e.pos.y, ADVANCE_BUTTON)) {
        this.audio.play('bellows_tap');
        this.done = true;
      }
    });
  }

  update(dt: number): void {
    this.elapsed += dt;
  }

  isComplete(): boolean {
    return this.done;
  }

  dispose(): void {
    this.unbind?.();
    this.unbind = null;
  }

  render(ctx: CanvasRenderingContext2D): void {
    const grad = ctx.createLinearGradient(0, 0, 0, LOGICAL_HEIGHT);
    grad.addColorStop(0, '#0e0608');
    grad.addColorStop(1, '#040203');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);

    ctx.fillStyle = this.summary.completed ? '#ffd84a' : '#ff7060';
    ctx.font = 'bold 28px system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(
      this.summary.completed ? 'MASTER SMITH' : 'THE FORGE CLOSES',
      LOGICAL_WIDTH / 2,
      48,
    );

    ctx.fillStyle = '#c9b896';
    ctx.font = '13px system-ui, sans-serif';
    ctx.fillText(
      this.summary.completed
        ? 'Your name will echo through the towns.'
        : 'Word spreads. The smithy goes quiet.',
      LOGICAL_WIDTH / 2,
      90,
    );

    // Stats panel.
    ctx.fillStyle = '#a8957a';
    ctx.font = '15px system-ui, sans-serif';
    ctx.textAlign = 'left';
    const px = 60;
    let py = 170;
    ctx.fillText(`Heroes saved:     ${this.summary.heroesSaved}`, px, py);
    py += 28;
    ctx.fillText(`Weapons forged:   ${this.summary.weaponsForged}`, px, py);
    py += 28;
    ctx.fillText(`Hall-of-Fame:     ${this.summary.hallOfFameCount}`, px, py);
    py += 28;
    ctx.fillText(`Gold earned:      ${this.summary.goldEarned}`, px, py);
    py += 36;
    ctx.fillStyle = '#ffd84a';
    ctx.font = 'bold 20px system-ui, sans-serif';
    ctx.fillText(`+${this.summary.renownAwarded} Renown`, px, py);

    drawButton(ctx, {
      rect: ADVANCE_BUTTON,
      label: 'RETURN TO MENU',
      enabled: this.elapsed > 1.0,
      highlight: true,
    });
  }
}
